/* eslint-env browser */
import Domodule from 'domodule';
import { findOne, on, toggleClass } from 'domassist';
import tinybounce from 'tinybounce';

class ToggleVisibility extends Domodule {
  postInit() {
    this.target = findOne(this.options.target);
    this.hidden = true;
    this.height = this.target.firstElementChild.offsetHeight;
    on(window, 'resize', tinybounce(this.onResize.bind(this), 150));
  }

  onResize() {
    this.height = this.target.firstElementChild.offsetHeight;

    if (!this.hidden) {
      this.target.style.maxHeight = `${this.height}px`;
    }
  }

  click(el, event) {
    event.preventDefault();
    this.hidden = !this.hidden;
    const height = this.hidden ? 0 : this.height;

    if (!this.hidden) {
      el.innerHTML = this.options.hide;
    } else {
      el.innerHTML = this.options.show;
    }

    toggleClass(el, 'expanded');
    this.target.style.maxHeight = `${height}px`;
  }
}

Domodule.register('ToggleVisibility', ToggleVisibility);
